import Immutable from "seamless-immutable";
import {
  RESET_PASSWORD_RECEIVE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_FAILURE,
  EMAIL_SIGNUP_RECEIVE,
  EMAIL_SIGNUP_REQUEST,
  EMAIL_SIGNUP_FAILURE,
  HATCH_FOR_WORK_SIGNUP_RECEIVE,
  HATCH_FOR_WORK_SIGNUP_REQUEST,
  HATCH_FOR_WORK_SIGNUP_FAILURE,
} from "../types/User";
import { REHYDRATION_COMPLETE, APP_ERROR } from "../types/App";

// Create initial Redux State for "user"
const INITIAL_STATE = Immutable({
  resetRequestSent: false,
  signupRequestSent: false,
  hatchForWorkRequestSent: false,
  sending: false,
  data: {},
  errors: {},
});

const UserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP_ERROR:
      return state.merge({
        resetRequestSent: false,
        signupRequestSent: false,
        hatchForWorkRequestSent: false,
        sending: false,
      });
    case HATCH_FOR_WORK_SIGNUP_RECEIVE:
      return state.merge({
        hatchForWorkRequestSent: true,
        sending: false,
        errors: {},
        data: { value: action.payload },
      });
    case RESET_PASSWORD_RECEIVE:
      return state.merge({
        resetRequestSent: true,
        sending: false,
        errors: {},
      });
    case EMAIL_SIGNUP_RECEIVE:
      return state.merge({
        signupRequestSent: true,
        sending: false,
        errors: {},
        data: { value: action.payload },
      });
    case HATCH_FOR_WORK_SIGNUP_REQUEST:
      return state.merge({
        hatchForWorkRequestSent: false,
        sending: true,
      });
    case EMAIL_SIGNUP_REQUEST:
      return state.merge({
        signupRequestSent: false,
        sending: true,
      });
    case RESET_PASSWORD_REQUEST:
      return state.merge({
        resetRequestSent: false,
        sending: true,
      });
    case HATCH_FOR_WORK_SIGNUP_FAILURE:
      return state.merge({
        hatchForWorkRequestSent: true,
        sending: false,
        errors: action.errors,
      });
    case EMAIL_SIGNUP_FAILURE:
      return state.merge({
        signupRequestSent: true,
        sending: false,
        errors: action.errors,
      });
    case RESET_PASSWORD_FAILURE:
      return state.merge({
        resetRequestSent: true,
        sending: false,
        errors: action.errors,
      });
    case REHYDRATION_COMPLETE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default UserReducer;
